import { Gift } from 'lucide-react';
import { Card, CardContent } from '@/components/molecules/Card';
import styles from './RewardsPage.module.scss';

/**
 * Company Rewards — placeholder. Later, company admins will be able to create their
 * own redeemable rewards for employees. For now we just leave the entry prepared.
 */
export function RewardsPage() {
  return (
    <div className={styles.rewardsPage}>
      <div className={styles.rewardsPage__header}>
        <h1 className={styles.rewardsPage__title}>Rewards</h1>
        <p className={styles.rewardsPage__subtitle}>
          Create custom redeemable rewards for your employees
        </p>
      </div>

      <Card>
        <CardContent>
          <div className={styles.rewardsPage__placeholder}>
            <span className={styles.rewardsPage__placeholderIcon}>
              <Gift size={28} aria-hidden />
            </span>
            <p className={styles.rewardsPage__placeholderTitle}>Coming soon</p>
            <p className={styles.rewardsPage__placeholderText}>
              Soon you'll be able to create your own rewards for employees to redeem with
              their points.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default RewardsPage;
